<template>
  <header
    id="mt-header"
    class="in-viewport"
    :class="{
      navOpen: navigationToggle,
      open_submenu:
        normalizedRoutePathLower.includes('/solutions') ||
        // $route.path.includes('/markets') ||
        normalizedRoutePathLower.includes('/agency') ||
        normalizedRoutePathLower.includes('/inclusion'),
    }"
    v-in-viewport="{}"
  >
    <div class="inside">
      <a href="/" id="mt-logo-container">
        <img
          class="mt-logo"
          :src="setLogoUrl()"
          alt="Marcus Thomas LLC Logotype"
        />
      </a>

      <template
        v-if="false"
      >
        <div
          class="cx-2-header"
          v-if="normalizedRoutePathLower == '/cx2'"
        >
          <a href="#" v-in-viewport="{}" v-scroll-to="'#contact-form'"
            >Contact us</a
          >
          <span class="divider">|</span> <span>216.285.2849</span>
        </div>

        <div
          class="icon-menu"
          @click="openNavigation()"
          :class="{ scrollDown: scrollDown }"
          v-if="normalizedRoutePathLower != '/cx2'"
        >
          <span class="icon-menu-hamburger"></span>
        </div>

        <section class="full-navigation">
          <ul class="menu">
            <li :class="['hide-desktop', { fadeInDown: navigationToggle }]">
              <router-link v-bind:to="'/'" class="home" @click="openNavigation()" 
                >Home</router-link
              >
            </li>
            <li :class="{ fadeInDown: navigationToggle }">
              <router-link v-bind:to="'/work'" @click="openNavigation()" 
                >Work</router-link
              >
            </li>
            <li :class="{ fadeInDown: navigationToggle }">
              <a
                id="sub_solutions"
                href="/solutions"
                title="Solutions"
                :class="
                  $route.path.includes('/solutions')
                    ? 'submenu router-link-active'
                    : 'submenu'
                "
                @click="openNavigation()"
                >Solutions</a
              >
              <sub-menu
                :moreList="solutions"
                :baseUrl="'/solutions'"
                :isSticky="true"
              ></sub-menu>
            </li>
            <!-- <li :class="{ fadeInDown: navigationToggle }">
              <a id="sub_markets" href="/markets"  title="Markets" :class="($route.path.includes('/markets')?'submenu router-link-active':'submenu')" v-on:click="openNavigation()">Markets</a>
              <router-link
                v-bind:to="'/markets'"
                id="sub_markets"
                title="Markets"
                :class="
                  $route.path.includes('/markets')
                    ? 'submenu router-link-active'
                    : 'submenu'
                "
                v-on:click="openNavigation()"
                >Markets</router-link
              >
              <sub-menu
                :moreList="markets"
                :baseUrl="'/markets'"
                :isSticky="false"
              ></sub-menu>
            </li> -->
            <li :class="{ fadeInDown: navigationToggle }">
              <router-link v-bind:to="'/words'" @click="openNavigation()" 
                >Insights</router-link
              >
            </li>
            <li :class="{ fadeInDown: navigationToggle }">
              <router-link v-bind:to="'/agency'" @click="openNavigation()" 
                >Agency</router-link
              >
            </li>
            <li :class="{ fadeInDown: navigationToggle }">
              <router-link
                v-bind:to="'/inclusion'"
                id="sub_inclusion"
                title="Inclusion"
                :class="
                  $route.path.includes('/inclusion')
                    ? 'router-link-active'
                    : ''
                "
                @click="openNavigation()"
                >Inclusion</router-link
              >
              <!-- <router-link v-bind:to="'/inclusion'" v-on:click="openNavigation()">Inclusion</router-link> -->
              <!-- <sub-menu
                :moreList="inclusion"
                :baseUrl="'/inclusion'"
                :isSticky="false"
              ></sub-menu> -->
            </li>
            <li :class="{ fadeInDown: navigationToggle }">
              <a
                :class="
                  $route.path.includes('/careers') ||
                  $route.path.includes('/jobs')
                    ? 'router-link-active'
                    : ''
                "
                href="/careers"
                title="Careers"
                @click="openNavigation()" 
                >Careers</a
              >
            </li>
            <li class="hide-mobile">
              <router-link to="/contact" tag="button" class="btn_orange"
                >Contact Us</router-link
              >
            </li>
            <li :class="['hide-desktop', { fadeInDown: navigationToggle }]">
              <a
                :class="
                  $route.path.includes('/contact') ? 'router-link-active' : ''
                "
                href="/contact"
                title="Contact"
                @click="openNavigation()" 
                >Contact Us</a
              >
            </li>
            <li class="direct-diversity">
              <router-link to="/agency/diversity">
                <img src="/dist/icn_diversity.jpg" alt="Diversity" class="" />
              </router-link>
            </li>
          </ul>
        </section>
      </template>
    </div>
  </header>
</template>

<script>
import apiConnection from "../mixins/apiConnection.js";
import subMenu from "../components/submenu.vue";
require("../assets/img/plus-button.svg");
require("../assets/img/minus-button.svg");
require("../assets/img/icn_diversity.jpg");

var previousScroll = 0;
export default {
  name: "Header",
  mixins: [apiConnection],
  computed: {
    normalizedRoutePath() {
      const currentPath = (this.$route && this.$route.path) || "/";
      if (currentPath.length > 1 && currentPath.endsWith("/")) {
        return currentPath.slice(0, -1);
      }
      return currentPath;
    },
    normalizedRoutePathLower() {
      return this.normalizedRoutePath.toLowerCase();
    },
  },
  data() {
    return {
      navigationToggle: false,
      isBlack: false,
      scrollDown: false,
      solutions: [],
      markets: [],
      inclusion: [],
      headers: [],
      agency_subpages: [],
    };
  },
  methods: {
    handleResize: function () {
      var slickNode = document.getElementById("slick-in");

      if (!this.$breakpoints.isTablet() && !this.$breakpoints.isMobile()) {
        this.isBlack = false;
        document.body.className = "";
        this.navigationToggle = false;

        if (slickNode) {
          slickNode.classList.add("fire-slick");
          this.slickInit();
        }
      } else if (slickNode) {
        //$('.fire-slick').slick('unslick');
        slickNode.classList.remove("fire-slick");
      }
    },
    openNavigation: function () {
      if (this.$breakpoints.isTablet() || this.$breakpoints.isMobile()) {
        this.navigationToggle = !this.navigationToggle;
        if (this.navigationToggle) {
          this.isBlack = false;
          document.body.className = "openMenuFix";
        } else {
          this.changeHeaderColor();
          window.scrollTo(0, 0);
          document.body.className = "";
        }
      }
    },
    setLogoUrl: function () {
      // if(this.isBlack) return require('../assets/img/mt-logo-2015-black.svg');
      // else return require('../assets/img/mt-logo-2015.svg');
      return require("../assets/img/mt-logo-2015.svg");
    },
    handleScroll: function (e) {
      var isMSIE = /*@cc_on!@*/ 1;
      window.onload = function () {
        if (!isMSIE) {
          // do IE-specific things
          var currentScroll = e.view.scrollY;
        } else {
          var currentScroll = e.path[1].scrollY;
        }

        //console.log(currentScroll);
        if (currentScroll > previousScroll) {
          this.scrollDown = true;
        } else {
          this.scrollDown = false;
        }
        previousScroll = currentScroll;
      };
    },
    changeHeaderColor: function () {
      // if these pages are on - > show black
      /*
        if((this.$route.path == '/work')||(this.$route.path == '/terms')||(this.$route.path.indexOf("/work/") !== -1  )||(this.$route.path == '/privacy')||(this.$route.path == '/404')) this.isBlack = true;
        else this.isBlack = false;
        */

      //($route.path != '/healthcare')

      this.isBlack = false;
    },

    slickInit: function () {
      $(".fire-slick:not(.slick-initialized)").slick({
        infinite: false,
        speed: 200,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        prevArrow: '<span class="prevArrow"></span>',
        nextArrow: '<span class="nextArrow"></span>',
        responsive: [
          {
            breakpoint: 1025,
            settings: "unslick",
          },
        ],
      });
      //Set current slider in current menu page
      //var s = $('.fire-slick .slick-slide:not(.slick-cloned)').find('.item.active').closest('.slick-slide').attr('data-slick-index');
      //$('.fire-slick').slick('slickGoTo',s,false);
      //  $('.fire-slick').slick('slickGoTo',s,false);

      // On before slide change
      var currentPath = this.$route.path;
      $(".fire-slick").on("afterChange", function (event, slick, currentSlide) {
        console.log(currentSlide);
        //sessionStorage.setItem('current-slider', JSON.stringify(currentSlide));

        if (currentSlide != 0) {
          if (currentPath.indexOf("/solutions") !== -1) {
            sessionStorage.setItem("solutions-current-slider", currentSlide);
          }
        } else {
          sessionStorage.setItem("solutions-current-slider", currentSlide);
        }
      });

      if (
        currentPath.indexOf("/solutions") !== -1 &&
        sessionStorage.getItem("solutions-current-slider")
      ) {
        $(".fire-slick").slick(
          "slickGoTo",
          parseInt(sessionStorage.getItem("solutions-current-slider")),
          false
        );
      }
    },
    openCurrAccordion: function (e) {
      console.log(e);
      if (this.$breakpoints.isTablet() || this.$breakpoints.isMobile()) {
        for (var i = 0; i < this.headers.length; i++) {
          var parent = this.headers[i].parentElement;
          var article = this.headers[i].nextElementSibling;

          if (
            e.target === this.headers[i] &&
            !parent.classList.contains("open")
          ) {
            parent.classList.add("open");
          } else {
            parent.classList.remove("open");
          }
          e.preventDefault();
        }
      }
    },
  },
  created() {
    this.changeHeaderColor();
    window.addEventListener("scroll", this.handleScroll);
    this.getSolutions(100);
    this.getMarkets(100);
    this.getInclusion(100);
    this.getAgencySubpages(10);
  },
  mounted() {
    previousScroll = window.scrollY;
    window.addEventListener("resize", this.handleResize);
    this.headers = document.querySelectorAll(".submenu");

    for (var i = 0; i < this.headers.length; i++) {
      this.headers[i].addEventListener("click", this.openCurrAccordion);
    }

    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.slickInit();

        // let test = this.inclusion;
        // // console.log(test, "n\ test-->>>", JSON.parse(JSON.stringify(test)));
        // for (var i in test) {
        //   console.log(
        //     "INLCUSION -->>>",
        //     JSON.parse(JSON.stringify(test[i].elements.page_name.value))
        //   );
        // }
      }
    };
  },
  watch: {
    // if route change..
    $route: function () {
      $("#footer").hide();
      window.scrollTo(0, 0);
      this.changeHeaderColor();

      if (this.$route.path.indexOf("/solutions") === -1) {
        sessionStorage.clear();
      }
    },
  },
  components: {
    "sub-menu": subMenu,
  },
};
</script>



// WEBPACK FOOTER //
// header-component.vue?2e7b8b2a